import actions from '../action/coupon'
import CONSTANT from '../constant/coupon'
import { Toast } from 'mint-ui'
import _ from 'underscore'

export default {
    actions,
    state: {
        currentCouponList: [],
        // currentCouponDetail: {},
    },
    getters: {

    },
    mutations: {
        clearCouponList(state) {
            return state.currentCouponList = []
        },
        [CONSTANT.COUPON_BINDINGCOUPON_SUCCESS] (state, data) {
            // state.currentCouponDetail = data
            state.currentCouponList.unshift(data)
        },
        [CONSTANT.COUPON_BINDINGCOUPON_ERROR] (state, e) {

        },
        [CONSTANT.COUPON_GETCOUPONLIST_SUCCESS] (state, data) {
            let list = state.currentCouponList.concat(data.list || [])
            state.currentCouponList = _.uniq(list, (coupon) => {
                return coupon.couponsCodeId
            })
        },
        [CONSTANT.COUPON_GETCOUPONLIST_ERROR] (state, e) {

        },
        [CONSTANT.COUPON_GETCOUPONCOUNT_SUCCESS] (state, data) {

        },
        [CONSTANT.COUPON_GETCOUPONCOUNT_ERROR] (state, e) {

        },
        /*yeoman-template-point-1*/
    }
}
